module.exports = __webpack_public_path__ + "img/bell.2c048ca7.svg";